import request from '@/utils/request'

/**
 * @param {import('@/types/generated/openapi').paths['/doc/get_menu_list']['get']['parameters']['query']} params
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/doc/get_menu_list']['get']['responses']['200']['content']['application/json']>>}
 */
export function getDocmenuList(params) {
  return request({
    url: 'doc/get_menu_list',
    method: 'get',
    params
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/doc/create_menu']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/doc/create_menu']['post']['responses']['200']['content']['application/json']>>}
 */
export function createDocmenu(data) {
  return request({
    url: 'doc/create_menu',
    method: 'post',
    data
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/doc/delete_menu']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/doc/delete_menu']['post']['responses']['200']['content']['application/json']>>}
 */
export function deleteDocmenu(data) {
  return request({
    url: 'doc/delete_menu',
    method: 'post',
    data
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/doc/update_menu_title']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/doc/update_menu_title']['post']['responses']['200']['content']['application/json']>>}
 */
export function updateDocmenuTitle(data) {
  return request({
    url: 'doc/update_menu_title',
    method: 'post',
    data
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/doc/get_doc_content']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/doc/get_doc_content']['post']['responses']['200']['content']['application/json']>>}
 */
export function getDocContent(data) {
  return request({
    url: 'doc/get_doc_content',
    method: 'post',
    data
  })
}

/**
 * @param {import('@/types/generated/openapi').paths['/doc/update_doc_content']['post']['requestBody']['content']['application/json']} data
 * @returns {Promise<import('@/types/utils').R<import('@/types/generated/openapi').paths['/doc/update_doc_content']['post']['responses']['200']['content']['application/json']>>}
 */
export function updateDocContent(data) {
  return request({
    url: 'doc/update_doc_content',
    method: 'post',
    data
  })
}
